<template>
  <svg
    viewBox="0 0 340 430"
    width="340"
    height="430"
    class="gx-tree"
    :style="{ filter: treeFilter, transition: 'filter 1.2s ease' }"
  >
    <ellipse cx="170" cy="410" rx="90" ry="10" fill="rgba(212,169,70,.18)" />
    <ellipse cx="170" cy="410" rx="52" ry="6" fill="rgba(212,169,70,.22)" />

    <!-- Stage 0: 种子 -->
    <g v-if="stage === 0">
      <ellipse cx="170" cy="404" rx="14" ry="9" fill="#7B4F12" style="animation: gx-seedGlow 2s ease-in-out infinite" />
      <ellipse cx="170" cy="402" rx="9" ry="6" fill="#D4A946" opacity=".75" />
      <ellipse cx="170" cy="400" rx="5" ry="3" fill="#FFD700" opacity=".5" />
      <circle v-for="i in 6" :key="i" :cx="170 + Math.cos(i * Math.PI / 3) * 30" :cy="410 + Math.sin(i * Math.PI / 3) * 30 * .22" r="1.4" fill="rgba(212,169,70,.35)" />
    </g>

    <!-- Stage 1: 发芽 -->
    <g v-else-if="stage === 1">
      <path d="M170,410 C173,392 168,382 170,366" stroke="#5C3A1E" stroke-width="3" fill="none" stroke-linecap="round" />
      <ellipse cx="155" cy="377" rx="13" ry="7" fill="rgba(34,139,34,.82)" transform="rotate(-32 155 377)" />
      <ellipse cx="183" cy="375" rx="12" ry="6" fill="rgba(46,160,46,.78)" transform="rotate(28 183 375)" />
      <ellipse cx="170" cy="366" rx="10" ry="7" fill="rgba(30,130,30,.8)" />
    </g>

    <!-- Stage 2: 小树 -->
    <g v-else-if="stage === 2">
      <path d="M170,410 C174,355 167,315 170,265" stroke="#5C3A1E" stroke-width="6" fill="none" stroke-linecap="round" />
      <path v-for="b in branches2" :key="b.d" :d="b.d" stroke="#6B4218" :stroke-width="b.sw" fill="none" stroke-linecap="round" />
      <ellipse v-for="(l, i) in leaves2" :key="i" :cx="l.cx" :cy="l.cy" :rx="l.r" :ry="l.r * .78" :fill="i % 2 === 0 ? 'rgba(22,118,22,.78)' : 'rgba(34,140,34,.72)'" />
    </g>

    <!-- Stage 3: 大树 -->
    <g v-else-if="stage === 3">
      <path d="M170,410 C175,335 166,265 171,195" stroke="#4A2C0A" stroke-width="9" fill="none" stroke-linecap="round" />
      <path v-for="r in roots3" :key="r.d" :d="r.d" stroke="rgba(50,30,8,.6)" :stroke-width="r.sw" fill="none" stroke-linecap="round" />
      <path v-for="b in branches3" :key="b.d" :d="b.d" stroke="#5C3A1E" :stroke-width="b.sw" fill="none" stroke-linecap="round" />
      <ellipse v-for="(l, i) in leaves3" :key="i" :cx="l.cx" :cy="l.cy" :rx="l.r" :ry="l.r * .77" :fill="leaves3Fill[i % 4]" />
    </g>

    <!-- Stage 4: 参天大树 -->
    <g v-else>
      <path d="M170,410 C176,318 165,232 171,110" stroke="#3C2008" stroke-width="14" fill="none" stroke-linecap="round" />
      <path v-for="r in roots4" :key="r.d" :d="r.d" stroke="rgba(44,26,6,.7)" :stroke-width="r.sw" fill="none" stroke-linecap="round" />
      <path v-for="b in branches4" :key="b.d" :d="b.d" :stroke="b.stroke" :stroke-width="b.sw" fill="none" stroke-linecap="round" />
      <ellipse v-for="(l, i) in leaves4" :key="i" :cx="l.cx" :cy="l.cy" :rx="l.r" :ry="l.r * .8" :fill="leaves4Fill[i % 5]" />
      <ellipse cx="170" cy="55" rx="24" ry="15" fill="rgba(212,169,70,.2)" style="animation: gx-canopyBreathe 3s ease-in-out infinite" />
    </g>

    <!-- 星星人 -->
    <g v-if="stage >= 2" transform="translate(192,408) scale(2)" stroke="rgba(255,255,255,.82)" stroke-width="1.5" stroke-linecap="round" fill="none">
      <circle cx="0" cy="-17" r="3" stroke-width="1.3" />
      <line x1="0" y1="-14" x2="0" y2="-7" />
      <line x1="0" y1="-13" x2="-4.5" y2="-9.5" />
      <line x1="0" y1="-13" x2="3.5" y2="-8.5" />
      <line x1="0" y1="-7" x2="-2.5" y2="0" />
      <line x1="0" y1="-7" x2="2.5" y2="0" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HeroTree',
  props: {
    stage: { type: Number, default: 0 }
  },
  computed: {
    treeFilter() {
      if (this.stage === 4) return 'drop-shadow(0 0 28px rgba(212,169,70,.45))'
      if (this.stage >= 2) return 'drop-shadow(0 0 12px rgba(20,100,20,.3))'
      return 'none'
    },
    branches2() {
      return [
        { d: 'M170,338 Q136,318 122,338', sw: 2.4 },
        { d: 'M170,334 Q214,314 218,334', sw: 2.4 },
        { d: 'M170,292 Q120,272 120,292', sw: 2 },
        { d: 'M170,288 Q218,268 218,288', sw: 2 }
      ]
    },
    leaves2() {
      return [
        { cx: 122, cy: 338, r: 22 }, { cx: 214, cy: 334, r: 20 },
        { cx: 120, cy: 292, r: 20 }, { cx: 218, cy: 288, r: 18 },
        { cx: 170, cy: 262, r: 27 }, { cx: 148, cy: 252, r: 18 },
        { cx: 190, cy: 255, r: 16 }
      ]
    },
    roots3() {
      return [
        { d: 'M170,410 Q118,415 98,410', sw: 2.2 },
        { d: 'M170,410 Q222,413 242,410', sw: 2.2 },
        { d: 'M170,410 Q166,428 166,410', sw: 2.2 }
      ]
    },
    branches3() {
      return [
        { d: 'M170,320 Q115,300 105,255', sw: 5.5 },
        { d: 'M170,317 Q225,297 233,255', sw: 5.5 },
        { d: 'M170,268 Q125,250 122,192', sw: 4.5 },
        { d: 'M170,265 Q215,247 218,192', sw: 4.5 },
        { d: 'M170,222 Q140,208 140,162', sw: 4 },
        { d: 'M170,220 Q200,206 200,165', sw: 4 }
      ]
    },
    leaves3() {
      return [
        { cx: 170, cy: 190, r: 40 }, { cx: 112, cy: 242, r: 30 },
        { cx: 226, cy: 245, r: 28 }, { cx: 128, cy: 212, r: 26 },
        { cx: 210, cy: 214, r: 24 }, { cx: 170, cy: 168, r: 30 },
        { cx: 146, cy: 158, r: 20 }, { cx: 192, cy: 161, r: 18 },
        { cx: 108, cy: 262, r: 22 }, { cx: 230, cy: 265, r: 20 }
      ]
    },
    leaves3Fill() {
      return ['rgba(20,108,20,.8)', 'rgba(28,130,28,.75)', 'rgba(15,90,15,.78)', 'rgba(34,148,34,.72)']
    },
    roots4() {
      return [
        { d: 'M170,410 Q124,415 88,410', sw: 3 },
        { d: 'M170,410 Q216,414 252,410', sw: 3 },
        { d: 'M170,410 Q113,408 88,410', sw: 3 },
        { d: 'M170,410 Q228,406 252,410', sw: 2.6 },
        { d: 'M170,410 Q110,404 88,410', sw: 2.4 },
        { d: 'M170,410 Q228,404 252,410', sw: 2.4 }
      ]
    },
    branches4() {
      return [
        { d: 'M170,302 Q106,282 86,218', sw: 6.5, stroke: '#4A2C0A' },
        { d: 'M170,299 Q234,279 254,219', sw: 6.5, stroke: '#4A2C0A' },
        { d: 'M170,252 Q92,234 72,154', sw: 5.5, stroke: '#5C3A1E' },
        { d: 'M170,249 Q248,231 266,155', sw: 5.5, stroke: '#5C3A1E' },
        { d: 'M170,208 Q120,192 120,122', sw: 5, stroke: '#5C3A1E' },
        { d: 'M170,206 Q220,190 220,124', sw: 5, stroke: '#5C3A1E' },
        { d: 'M170,168 Q148,156 148,96', sw: 4.5, stroke: '#5C3A1E' },
        { d: 'M170,167 Q192,155 192,101', sw: 4.5, stroke: '#5C3A1E' },
        { d: 'M170,140 Q158,132 158,82', sw: 4, stroke: '#5C3A1E' },
        { d: 'M170,139 Q182,131 182,84', sw: 4, stroke: '#5C3A1E' }
      ]
    },
    leaves4() {
      return [
        { cx: 170, cy: 110, r: 46 }, { cx: 95, cy: 155, r: 36 },
        { cx: 243, cy: 158, r: 34 }, { cx: 120, cy: 125, r: 32 },
        { cx: 218, cy: 128, r: 30 }, { cx: 170, cy: 86, r: 38 },
        { cx: 75, cy: 188, r: 32 }, { cx: 263, cy: 192, r: 30 },
        { cx: 108, cy: 102, r: 28 }, { cx: 230, cy: 105, r: 26 },
        { cx: 55, cy: 222, r: 28 }, { cx: 283, cy: 226, r: 26 },
        { cx: 140, cy: 80, r: 30 }, { cx: 198, cy: 83, r: 28 },
        { cx: 170, cy: 68, r: 32 }, { cx: 88, cy: 132, r: 26 },
        { cx: 250, cy: 135, r: 24 }, { cx: 134, cy: 148, r: 28 },
        { cx: 204, cy: 152, r: 26 }, { cx: 66, cy: 168, r: 24 },
        { cx: 272, cy: 172, r: 22 }, { cx: 154, cy: 62, r: 24 },
        { cx: 186, cy: 65, r: 22 }, { cx: 115, cy: 90, r: 22 },
        { cx: 222, cy: 93, r: 20 }, { cx: 170, cy: 52, r: 26 }
      ]
    },
    leaves4Fill() {
      return ['rgba(18,102,18,.82)', 'rgba(26,128,26,.78)', 'rgba(14,88,14,.80)', 'rgba(34,148,34,.74)', 'rgba(22,118,22,.76)']
    }
  }
}
</script>

<style scoped>
.gx-tree {
  display: block;
  animation: gx-treeBreathe 4s ease-in-out infinite;
}
</style>
